import { render, staticRenderFns } from "./ReserveListNotify.vue?vue&type=template&id=60fb14cc&scoped=true&"
import script from "./ReserveListNotify.vue?vue&type=script&lang=js&"
export * from "./ReserveListNotify.vue?vue&type=script&lang=js&"
import style0 from "./ReserveListNotify.vue?vue&type=style&index=0&id=60fb14cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb14cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VRow})
